module.exports = __webpack_public_path__ + "static/media/FMB_icon11.b6d645b8.svg";